import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { AvisoService } from 'src/app/core/service/aviso/aviso.service';

@Component({
  imports: [CommonModule],
  selector: 'app-upload-arquivo',
  templateUrl: './upload-arquivo.component.html',
  styleUrls: ['./upload-arquivo.component.css']
})
export class UploadArquivoComponent {
  @Input() formatosAceitos: string[] = ['application/pdf', 'image/jpeg', 'image/png', 'image/webp'];
  @Input() tamanhoArquivo: any;
  @Input() tamanhoMaximoMB: number = 10;
  @Input() alturaCard: string = '350px';
  @Input() textoTipoETamanho: string = 'Formatos aceitos: PDF, JPG, JPEG, PNG (máx. 10MB)';
  @Input() nomeArquivo: string = 'Selecione o arquivo';
  @Input() urlDocumentoSelecionado: any;
  @Output() arquivoSelecionado = new EventEmitter();
  tipoArquivo: string = '';
  pdfSelecionado: boolean = false;
  documentoSelecionado: any;

  constructor(private readonly avisoService: AvisoService) { }

  Upload(evento: any) {
    let tamanhoMB = evento.target.files[0].size / (1024 * 1024);

    if (tamanhoMB > this.tamanhoMaximoMB) {
      evento.target.value = '';
      this.avisoService.Erro(`Arquivo maior que o permitido (${this.tamanhoMaximoMB} MB).`);
    } 
    else 
    {

      const file = evento.target.files[0];

      if (!this.formatosAceitos.includes(file.type)) {
        this.avisoService.Erro(`Formato inválido!`);
        return;
      }

      this.documentoSelecionado = evento.target.files[0];
      this.arquivoSelecionado.emit(this.documentoSelecionado);

      if (!this.documentoSelecionado) return;

      this.nomeArquivo = file.name;
      this.tipoArquivo = file.type;
      this.tamanhoArquivo = this.formatarTamanho(file.size);

      if (file.type.startsWith('image/')) {
        this.pdfSelecionado = false;
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.urlDocumentoSelecionado = e.target.result;
        };
        reader.readAsDataURL(file);
      } else if (file.type === 'application/pdf') {
        this.urlDocumentoSelecionado = null;
        this.pdfSelecionado = true;
      } else {
        this.urlDocumentoSelecionado = null;
        this.pdfSelecionado = false;
      }
    }
  }

  formatarTamanho(bytes: number): string {
    if (bytes < 1024) return `${bytes} B`;
    else if (bytes < 1048576) return `${(bytes / 1024).toFixed(1)} KB`;
    else return `${(bytes / 1048576).toFixed(1)} MB`;
  }
}